import { SelectOption } from '../Select.types';
import { UI_CONSTANTS } from './constants';

/**
 * Normalizes value to array format for consistent handling
**/
export const normalizeValue = (value: string | string[] | undefined, isMulti: boolean): string[] => {
  if (value === undefined || value === null || value === '') return [];

  if (isMulti) {
    return Array.isArray(value) ? value : [value];
  }

  if (Array.isArray(value)) {
    return value.length > 0 ? [value[0]] : [];
  }
  return [value];
};



/**
 * Checks if "All" is selected (either explicitly or implicitly)
**/
export const isAllSelected = (
  selectedValues: string[], 
  showAllOption: boolean
): boolean => {
  if (!showAllOption) return false;
  
  return selectedValues.includes(UI_CONSTANTS.SPECIAL_VALUES.ALL);
};

/**
 * Filters options based on search term
**/
export const filterOptions = (
  options: SelectOption[],
  searchTerm: string,
  isRemote: boolean
): SelectOption[] => {
  const term = searchTerm.trim().toLowerCase();

  if (!term) {
    return options;
  }

  // 🔹 En búsqueda remota, el backend ya filtró
  if (isRemote) {
    return options; // puede ser [] si la API no encontró nada
  }

  // 🔹 Búsqueda local
  return options.filter(option =>
    option.label.toLowerCase().includes(term)
  );
};

/**
 * Gets display text for the select button
**/
export const getDisplayText = (
  selectedOptions: SelectOption[],
  allSelected: boolean,
  optionLabel: string,
  isMulti: boolean,
  loading: boolean
): string => {
  if (loading) return UI_CONSTANTS.MESSAGES.LOADING;
  
  if (allSelected) return optionLabel;
  
  if (selectedOptions.length === 0) return '';

  if (isMulti) {
    if (selectedOptions.length === 1) {
      return selectedOptions[0].label;
    }
    return `${selectedOptions.length} seleccionados`;
  }

  return selectedOptions[0]?.label || '';
};

/**
 * Validates if a new selection is allowed based on max selections
**/
export const canAddSelection = (
  currentSelections: string[],
  maxSelections?: number
): boolean => {
  if (!maxSelections) return true;
  return currentSelections.length < maxSelections;
};

/**
 * Gets all enabled option values
**/
export const getEnabledOptionValues = (options: SelectOption[]): string[] => {
  return options
    .filter(opt => !opt.disabled)
    .map(opt => opt.value);
};

/**
 * Removes special values from selection array
**/
export const removeSpecialValues = (values: string[]): string[] => {
  return values.filter(value => value !== UI_CONSTANTS.SPECIAL_VALUES.ALL);
};
